// src/padplanner/planStatus.js
//
// One color per plan status, for the pills, the dashboard bar and legend, and
// the map's outlines and pins, so a status reads the same everywhere.
//
// ── TOKENS, NOT HEX ────────────────────────────────────────────────────────
//
// The classes below are written out whole (Tailwind finds class names by
// reading the source, so a class assembled from parts is never generated). The
// map cannot use a class: statusColor() reads the same token from the CSS
// variable at run time, and falls back to the token's seeded value where no
// stylesheet is loaded (tests, a map built before CSS arrives).
//
// issued is accent-action, not the plan's accent-blue: --accent-blue is
// chrome-retired (tokens.css), kept only so its value is recoverable.

import { PLAN_STATUSES } from "./planVocabulary";

export const STATUS_STYLE = Object.freeze({
  draft:             { text: "text-fg-secondary",  bg: "bg-fg-secondary",  cssVar: "--text-3",      fallback: "147 166 184" },
  in_review:         { text: "text-status-busy",   bg: "bg-status-busy",   cssVar: "--status-busy", fallback: "22 242 212" },
  changes_requested: { text: "text-accent-red",    bg: "bg-accent-red",    cssVar: "--accent-red",  fallback: "239 68 68" },
  approved:          { text: "text-status-ok",     bg: "bg-status-ok",     cssVar: "--status-ok",   fallback: "47 191 113" },
  issued:            { text: "text-accent-action", bg: "bg-accent-action", cssVar: "--accent",      fallback: "58 174 232" },
});

/** The token's "r g b" triplet, as MapLibre wants it: rgb(r, g, b). */
export function statusColor(status) {
  const s = STATUS_STYLE[status] ?? STATUS_STYLE.draft;
  let triplet = "";
  try {
    triplet = getComputedStyle(document.documentElement).getPropertyValue(s.cssVar).trim();
  } catch {
    triplet = "";
  }
  const parts = (triplet || s.fallback).split(/\s+/).map(Number);
  return parts.length === 3 && parts.every(Number.isFinite) ? `rgb(${parts.join(", ")})` : `rgb(${s.fallback.split(" ").join(", ")})`;
}

/** A MapLibre expression coloring a feature by its `status` property. */
export function statusColorExpression() {
  const arms = PLAN_STATUSES.flatMap((s) => [s, statusColor(s)]);
  return ["match", ["get", "status"], ...arms, statusColor("draft")];
}
